import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { PublicLayout } from "./components/PublicLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Listings from "./pages/Listings";
import PropertyDetail from "./pages/PropertyDetail";
import { Neighborhoods, NeighborhoodDetail } from "./pages/Neighborhoods";
import { Journal, Article } from "./pages/Journal";
import Agents from "./pages/Agents";
import Sell from "./pages/Sell";
import Contact from "./pages/Contact";
import { Login, Register } from "./pages/Auth";
import Dashboard from "./pages/dashboard/Dashboard";
import VirtualTour from "./pages/VirtualTour";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="light" toastOptions={{ style: { background: "#ffffff", border: "1px solid #E4E7EC", color: "#11213f", borderRadius: 0 } }} />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/buy" element={<Listings mode="sale" />} />
              <Route path="/rent" element={<Listings mode="rent" />} />
              <Route path="/property/:id" element={<PropertyDetail />} />
              <Route path="/neighborhoods" element={<Neighborhoods />} />
              <Route path="/neighborhoods/:slug" element={<NeighborhoodDetail />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:slug" element={<Article />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/sell" element={<Sell />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/virtual-tour" element={<VirtualTour />} />
            <Route path="/virtual-tour/:id" element={<VirtualTour />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
